import $ from 'jquery';
import { syncNavMegamenuNavbarHeight } from './navMegamenuHelpers.js';

const initToaster = () => {
    const lastToaster = parseInt(localStorage.getItem('silae-toaster') ?? 1, 10),
        nowDate = Date.now();
    var closeButton = document.querySelector('.toaster button')
    var toaster = document.querySelector('.toaster')
    if (toaster) {
        const updateHeight = () => {

            /* Every hour */
            if (lastToaster && lastToaster + 1000 * 60 * 60 < nowDate) {
                var toaster = document.querySelector('.toaster')
                if (!toaster.classList.contains('closed')) {
                    toaster.style.maxHeight = "500px"
                    var height = toaster.querySelector('.toaster__content').getBoundingClientRect().height + 6 + 'px'
                    document.documentElement.style.setProperty('--toaster-height', height);
                }
            } else {
                var toaster = document.querySelector('.toaster')
                toaster.style.maxHeight = "0"
                toaster.classList.add('closed')
                document.documentElement.style.setProperty('--toaster-height', null);
            }
            syncNavMegamenuNavbarHeight();
        }
        const closeToaster = () => {
            var toaster = document.querySelector('.toaster')
            toaster.style.maxHeight = "0"
            toaster.classList.add('closed')
            document.documentElement.style.setProperty('--toaster-height', null);
            localStorage.setItem('silae-toaster', nowDate);
            syncNavMegamenuNavbarHeight();
        }
        updateHeight();
        closeButton.addEventListener('click', closeToaster)
        window.addEventListener('resize', updateHeight)
    }
};

export { initToaster };
